import React, { useState } from "react";
import { Modal, Input, Row, Button, Space, Select } from "antd";
import Title from "antd/es/typography/Title";
import {
  LockOutlined,
  UserOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { loginAuthorize } from "../../Helpers/apiCalls/authApi";
import toast from "react-hot-toast";
import { toastStyle, getRestoLogin } from "../../Helpers/Utils/Common";
import { UseGetRequest } from "../../Helpers/hooks/GetRequests";

export default function AuthenticationModal(props) {
  const { onShow, onSubmit, onCancel, action, subject } = props;
  const [saving, setSaving] = useState(false);
  const [openAuthenticate, setOpenAuthenticate] = useState(false);
  const [reason, setReason] = useState("");
  const [userOptions, setUserOptions] = useState([]);
  const [formInput, setFormInput] = useState({
    username: "",
    password: "",
  });

  async function handleAuthentication() {
    setSaving(true);
    const response = await loginAuthorize(
      formInput.username,
      formInput.password
    );
    if (response.data) {
      toast.success("Successful authentication", { style: toastStyle() });
      setTimeout(() => {
        onSubmit({
          ...response.data,
          reason: reason,
          password_string: formInput.password,
        });
      }, 500);
    } else {
      toast.error("Unauthorized user", { style: toastStyle() });
    }
    setSaving(false);
  }

  async function fetchAllUsers() {
    const response = await UseGetRequest("users/search", {}, getRestoLogin());
    if (response.data) {
      const res = response.data.map((row) => {
        return {
          value: row.username,
          label: row.username,
        };
      });
      setUserOptions(res);
    } else {
      setUserOptions([]);
    }
  }

  React.useEffect(() => {
    fetchAllUsers();
  }, []);

  return (
    <div>
      <Modal footer={null} open={onShow} onCancel={onCancel}>
        <div className="">
          <Row>
            <Row className="modal-text bolder">
              <ExclamationCircleOutlined className="me-2" />
              Are you sure you want to {action} this {subject}?
            </Row>
          </Row>
          <Row className="mt-2 modal-text">You cannot undo this action.</Row>
          <Row className="">
            <Input
              className="bigger-input-field"
              placeholder="Enter reason for deletion"
              onChange={(e) => setReason(e.target.value)}
            />
          </Row>
          <Row className="mt-4 d-flex justify-content-end">
            <Space>
              <Button onClick={onCancel} className="px-4 py-3 bigger-btn">
                Cancel
              </Button>
              <Button
                className="px-4 py-3 bigger-btn"
                danger
                onClick={() => setOpenAuthenticate(true)}
                disabled={reason.trim() === ""}
              >
                Confirm
              </Button>
            </Space>
          </Row>
        </div>
      </Modal>

      <Modal
        open={openAuthenticate}
        onCancel={() => setOpenAuthenticate(false)}
        footer={null}
        title="AUTHENTICATE"
      >
        <Row className="mt-3">
          {/* <Input
          className="bigger-input-field"
            prefix={<UserOutlined className="site-form-item-icon" />}
            placeholder="Username"
            onChange={(e) =>
              setFormInput((prev) => ({ ...prev, username: e.target.value }))
            }
          /> */}
          <div className="custom-select-container w-100">
            <UserOutlined className="custom-select-icon black" />
            <Select
              suffixIcon={null}
              placeholder="Username"
              options={userOptions}
              showSearch
              filterOption={(input, option) =>
                option.label?.toLowerCase().includes(input?.toLowerCase())
              }
              onChange={(e) =>
                setFormInput((prev) => ({ ...prev, username: e }))
              }
            />
          </div>
        </Row>
        <Row className="mt-2">
          <Input.Password
            className="bigger-input-field"
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Password"
            onChange={(e) =>
              setFormInput((prev) => ({ ...prev, password: e.target.value }))
            }
          />
        </Row>
        <Row className="mt-3 d-flex justify-content-end">
          <Space>
            <Button
              className="me-2 px-4 bigger-btn"
              onClick={() => {
                setOpenAuthenticate(false);
                onCancel();
              }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              className="px-4 bigger-btn"
              onClick={handleAuthentication}
              disabled={
                formInput.username === "" || formInput.password === "" || saving
              }
              loading={saving}
            >
              Submit
            </Button>
          </Space>
        </Row>
      </Modal>
    </div>
  );
}
